export default Object.freeze({
  list: [],
});
